import React, { Component } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

import SimpleReactValidator from 'simple-react-validator';

import UserCreateApi from '../../api/Scoreboardapi';
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import { Helmet } from 'react-helmet'

library.add(fas)

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            password_confirmation: '',
            alert:'',
            showModal: false,
        };

        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        document.body.style.backgroundImage="url(/images/loginbg.gif)";
    }

    handleChange = (event) => {
        let value = event.target.value
        if(event.target.name == 'password' || event.target.name == 'password_confirmation'){
            value = value.replace(/\s/g, '');
        }
        this.setState({[event.target.name]: value});
        this.validator.showMessageFor(event.target.name)
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

        if( this.validator.allValid() ){
            const formData={
                "Password" : this.state.password,
            };

            UserCreateApi.post('user/changepassword',formData)
            .then((res) => {
                // this.displayAlert(res.data.message, '', res.data.success == true ? 'success' : 'error')
                this.props.history.push('/dashboard');
            });
        }
        else
        {
            this.validator.showMessages();
        }
    }

    displayAlert=(title, message, type)=>{
        if(type == 'success') {
            this.setState({
                alert:< SweetAlert
                        success
                        title={title}
                        onConfirm={() => this.hideModel()} >
                        {message}
                    </SweetAlert>,
                showModal: ! this.state.showModal,
            })
        }
        else {
            this.setState({
                alert:< SweetAlert
                    error
                    title={title}
                    onConfirm={() => this.hideModel()} >
                    {message}
                </SweetAlert>,
                showModal: ! this.state.showModal,
            })
        }
    }

    render() {
        const { showModal } = this.state

        return (
            <>
                {
                    showModal ? (
                        <Modal>
                            {this.state.alert}
                        </Modal>
                    ) : null
                }
                <Helmet>
                    <title>Change Password | Scorecard</title>
                </Helmet>
                <div className="kt-grid kt-grid--ver kt-grid--root">
                    <div
                        id="kt_login"
                        className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
                    >
                        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
                            <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
                                <div className="kt-login__body log-in">
                                    <div className="kt-login__form">
                                        <div className="m-login__logo">
                                            <center>
                                            <a href="#" onClick={e => this.props.history.push('/dashboard')}>
                                                <img src="/images/referral-new-logo.png" />
                                            </a>
                                            </center>
                                        </div>
                                        <div>
                                            <div className="login-header p-0 pl-3">
                                                <FontAwesomeIcon icon={["fas", "user-secret"]} color="white" />
                                                <h4 className="py-3 pl-2 bg-dark text-white text-left mb-0 rounded-2 d-inline-block align-items-center rounded-top rounded-right">Change Password</h4>
                                            </div>
                                            <form className="m-login__form m-form bg-white pt-3 p-4" onSubmit={this.handleFormSubmit}>
                                                <div className="login-body">
                                                    <div className="form-group m-form__group pl-3 pr-3 has-error">
                                                        <input
                                                            className="rounded-0 form-control m-input m-login__form-input--last border bg-white"
                                                            required
                                                            type="password"
                                                            placeholder="Password"
                                                            name="password"
                                                            value={this.state.password}
                                                            onChange={this.handleChange} />
                                                        {this.validator.message('password', this.state.password, 'required', { className: 'text-danger' })}
                                                    </div>
                                                    <div className="form-group m-form__group pl-3 pr-3 has-error">
                                                        <input
                                                            className="rounded-0 form-control m-input m-login__form-input--last border bg-white"
                                                            required
                                                            type="password"
                                                            placeholder="Confirm Password"
                                                            name="password_confirmation"
                                                            value={this.state.password_confirmation}
                                                            onChange={this.handleChange} />
                                                        {this.validator.message('password_confirmation', this.state.password_confirmation, `required|in:${this.state.password}`, { className: 'text-danger' })}
                                                    </div>
                                                    <div className="m-login__form-action form-group m-form__group">
                                                        <button type="submit"  id="m_login_signin_submit" className="btn btn-primary btn-elevate kt-login__btn-primary font-weight-bold">
                                                            Update Password
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default (ChangePassword);
